import { device, withPlugins } from '@spon/plugins'
import raf from 'raf'
import anime from 'animejs'

function Hero({ node, plugins: { device } }) {
	const videoEl = node.querySelector(
		'.hero__video > video, .hero__video > iframe'
	)

	anime.set(videoEl, {
		opacity: 0,
	})

	const { clientWidth, clientHeight } = node

	function setVideoSize(width, height) {
		const { width: videoWidth, height: videoHeight } = videoEl
		const videoRatio = videoWidth / videoHeight

		videoEl.style.height = `${height}px`
		videoEl.style.width = `${height * videoRatio}px`

		if (videoEl.clientWidth < width) {
			videoEl.style.width = `${width}px`
			videoEl.style.height = `${width * (1 / videoRatio)}px`
		}

		anime({
			targets: videoEl,
			opacity: 1,
			easing: 'linear',
		})
	}

	setVideoSize(clientWidth, clientHeight)

	device.resize(() => {
		const { clientWidth, clientHeight } = node
		setVideoSize(clientWidth, clientHeight)
	})

	// Animating video messages
	// Get video messages
	const videoMessages = { ...JSON.parse(node.dataset.messages) }
	delete videoMessages['0']
	const $heroText = node.querySelector('.js-hero-text')
	let currIndex = 1

	function splitType(message) {
		return message.split('').reduce((acc, curr) => {
			acc += `<span>${curr}</span>` // eslint-disable-line
			return acc
		}, '')
	}

	// splitType(node.querySelector('.js-hero-text').innerText)

	function changeText(time) {
		// set message based on object (data-messages in DOM)
		Object.keys(videoMessages).forEach((key, index) => {
			const _key = parseInt(key, 0)

			if (_key > time - 1 && _key < time + 1) {
				if (currIndex === index) return false
				currIndex = index

				anime({
					targets: $heroText.querySelectorAll('span'),
					opacity: [1, 0],
					easing: 'linear',
					delay: anime.stagger(50),
					complete: () => {
						$heroText.innerHTML = splitType(videoMessages[key])

						anime({
							targets: $heroText.querySelectorAll('span'),
							opacity: [0, 1],
							easing: 'linear',
							delay: anime.stagger(50, { direction: 'reverse' }),
						})
					},
				})
			}
		})
	}

	let lastTime = 0

	function animate(currentTime) {
		if (currentTime >= lastTime + 1000) {
			// one second has passed, run some code here
			changeText(currentTime / 1000)
			lastTime = currentTime
		}

		raf(animate)
	}

	// const rafHandler = function tick(now) {
	// 	// Animation logic
	// 	if (!last || now - last >= 1000) {
	// 		last = now / 1000

	// 		changeText(last)
	// 	}

	// 	raf(tick)
	// }

	window.onload = () => {
		raf(animate)
	}

	// Observe the video element, so we can pause video when it's not inview
	// inview.observe({
	// 	enter: () => {
	// 		// Play video when video enters viewport
	// 		if (videoEl) videoEl.play()

	// 		raf(rafHandler)

	// 	},
	// 	exit: () => {
	// 		// Pause video when video leaves viewport
	// 		if (videoEl) videoEl.pause()
	// 		raf.cancel(rafHandler)
	// 	}
	// })

	return () => {
		// Disconnect intersection observer
		// inview.disconnect()
		// raf.cancel(rafHandler)
	}
}

export default withPlugins(device)(Hero)
